import React from 'react';
import './Info.css';

const Privacy = () => {
    return (
        <div className="info-page">
            <header className="info-hero">
                <div className="container">
                    <span className="section-eyebrow">DATA SECURITY</span>
                    <h1 className="terminal-title">Privacy Policy</h1>
                    <p className="terminal-desc">Your absolute data privacy is our elite priority. Discover how we protect your personal information.</p>
                </div>
                <div className="info-hero-orb"></div>
            </header>

            <main className="info-container">
                <section className="info-content">
                    <h2>Your Privacy at Bharatinsurex</h2>
                    <p>At Bharatinsurex, we are committed to protecting your privacy and ensuring you have a positive experience on our website and in using our services. This Privacy Policy outlines our high-performance practices regarding the collection, use, and disclosure of personal information.</p>
                    
                    <h3>1. Information Collection</h3>
                    <p>We collect personal information that you provide directly to us when you use our platform, including name, contact details, and financial information for insurance quotes. We also collect non-personal information through cookies to enhance your user experience.</p>

                    <h3>2. Use of Information</h3>
                    <p>The information we collect is used to personalize your experience, provide requested insurance services, and improve our platform's elite performance. We do not sell or lease your personal information to third parties.</p>

                    <h3>3. Data Security Measures</h3>
                    <p>We implement a variety of high-authority security measures to maintain the safety of your personal information when you enter, submit, or access your data. These include encrypted server communication and periodic security audits.</p>

                    <h3>4. Third-Party Disclosures</h3>
                    <p>We may share your information with trusted third-party insurance providers solely for the purpose of fulfilling your insurance requests. These third parties are prohibited from using your personal information for any other purpose.</p>

                    <h3>5. Cookie Policy</h3>
                    <p>Our website uses cookies to understand and save your preferences for future visits and compile aggregate data about site traffic and site interaction so that we can offer better site experiences and tools in the future.</p>

                    <h3>6. Consent</h3>
                    <p>By using our platform, you consent to our privacy policy. If we decide to change our privacy policy, we will post those changes on this page.</p>
                </section>
            </main>
        </div>
    );
};

export default Privacy;
